
<template>
  <v-card elevation="0" :outlined="outlined" style="border-radius: 6px; box-shadow: 0px 0px 4,72px 0px #000000 !important;" class="page-header">
    <v-card-title class="px-3 pt-3 pb-1">
      <span class="title-card ml-3">
        <slot name="title-left"></slot> 
      </span>
      <v-spacer></v-spacer>
      <slot name="title-right"></slot>
    </v-card-title>
    <v-card-text class="py-1 px-3">
      <slot name="content"></slot>
    </v-card-text>
    <v-card-actions class="pt-0 pb-3 px-3">
      <slot name="actions"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  name: 'DefaultCard',
  props: {
    outlined: {
      type: Boolean,
      default: () => true
    }
  }
}
</script>

<style scoped>

</style>